module.exports = __webpack_public_path__ + "img/more-horizontal.036a65bf.svg";